import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'ng-uikit-pro-standard';
import { DepositoDocumentoService } from 'src/app/services/deposito-documento.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { DestinoDepositoModalAgregarBancoComponent, IDepositoAgregado } from './modal-agregar-banco/modal-agregar-banco.component';
import * as _ from 'lodash'

@Component({
  selector: 'app-destino-deposito',
  templateUrl: './destino-deposito.component.html',
  styleUrls: ['./destino-deposito.component.scss'],
  providers: [SecurityService],
})
export class DestinoDepositoComponent implements OnInit {

  // Modales
  @ViewChild(DestinoDepositoModalAgregarBancoComponent, { static: true }) modalAgregarBanco: DestinoDepositoModalAgregarBancoComponent

  // Form
  formHeader: FormGroup

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalCodigo: number;
  loading: boolean = false
  listaMovimientos: Array<any> = null
  mainTotalPaginas: number
  mainTotalRegistros: number
  paginationContext: PaginationContext = new PaginationContext()
  enableContent: boolean = true

  // Utils
  private log: any

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private depositoDocumentoService: DepositoDocumentoService,
    private rutService: RutService
  ) {
    this.log = this.clog.log('DESTINO-DEPOSITO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10

    this.createForm()
    this.reset()
    this.loadData()
  }

  private createForm() {
    this.formHeader = this.fb.group({
      rut: [null, [Validators.required]],
      nombre: [null, [Validators.required]],
    });
  }

  back() {
    this.log('back')
    this.router.navigate(['/finanzas/depositoDocumentos'])
  }

  loadData() {
    this.activatedRoute.params.subscribe(params => {
      const id: string = params['id']
      console.log('param id', id)
      const data = this.depositoDocumentoService.rescatarPayload(id)
      if (!data || data.length === 0) {
        this.log(`no data for ${id}`)
        this.listaMovimientos = []
        return
      }
      this.log('data', data)// data[0].data)
      this.listaMovimientos = data[0].data.registros
      this.mainTotalPaginas = data[0].data.totalPaginas
      this.mainTotalRegistros = data[0].data.totalRegistros
      // this.heroe = this._heroesService.getHeroe( params['id'] );
    });
  }

  reset() {
    this.enableFormHeader()
    this.listaMovimientos = null
    this.mainTotalPaginas = null
    this.mainTotalRegistros = null
  }

  enableFormHeader() {
    this.formHeader.get('rut').enable()
    this.formHeader.get('nombre').enable()
    this.enableContent = true
  }

  disableFormHeader() {
    this.formHeader.get('rut').disable()
    this.formHeader.get('nombre').disable()
    this.enableContent = false
  }

  showModalAgregarBanco() {
    const valid = this.formValidatorsService.validate(this.formHeader)
    if (!valid) {
      this.toastService.error('Complete datos depositante')
      return
    }
    this.modalAgregarBanco.show()
  }

  onDepositoAgregado({
    banco: banco_codigo_cuenta_bancaria,
    cuenta: numero_cuenta,
    nroDeposito: numero_deposito,
    fechaDeposito: fecha_deposito,
    nombreBanco,
    tipo_cuenta_bancaria_codigo
  }: IDepositoAgregado) {
    this.log('agregar', { banco: banco_codigo_cuenta_bancaria, cuenta: numero_cuenta, nroDeposito: numero_deposito, fechaDeposito: fecha_deposito, nombreBanco, tipo_cuenta_bancaria_codigo })
    this.listaMovimientos.map(mov => {
      mov.banco_codigo_cuenta_bancaria = banco_codigo_cuenta_bancaria
      mov.tipo_cuenta_bancaria_codigo = tipo_cuenta_bancaria_codigo
      mov.numero_cuenta = numero_cuenta
      mov.numero_deposito = numero_deposito
      mov.fecha_deposito = fecha_deposito
      delete mov.__typename
      // mov.nombre_banco_destino = nombreBanco // quitar despues
    })

    const rutSinDv: number = this.rutService.QuitarDV(this.rutService.Limpiar(this.formHeader.get('rut').value))
    const inputParams = {
      entidad: {
        depositante_rut: rutSinDv,
        depositante_nombre: this.formHeader.get('nombre').value.trim(),
        banco_codigo_cuenta_bancaria,
        tipo_cuenta_bancaria_codigo,
        numero_cuenta,
        numero_deposito,
        fecha_deposito,
        lista: this.listaMovimientos
      },
      paginaActual: this.mainTotalPaginas,
      cantidadRegistrosPorPagina: this.mainTotalRegistros,
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.depositoDocumentoService.agregarBancoDepositante(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros } = respuesta
      this.listaMovimientos = registros
      this.listaMovimientos.map(mov => {
        mov.additionalData = {}
        mov.additionalData.nombre_banco_destino = nombreBanco // quitar despues
      })

      this.disableFormHeader()
    })

  }

  guardarDeposito() {
    const lista = _.cloneDeep(this.listaMovimientos)
    lista.map(p => {
      delete p.additionalData
      delete p.__typename
    })
    const inputParams = {
      entidad: {
        lista
      },
      paginaActual: this.mainTotalPaginas,
      cantidadRegistrosPorPagina: this.mainTotalRegistros,
    }

    this.log('inputParams', JSON.stringify(inputParams))
    this.depositoDocumentoService.guardarDepositoDocumento(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, totalPaginas, totalRegistros } = respuesta

      this.enableFormHeader()
      this.reset()

      // const index: string = this.depositoDocumentoService.guardarPayload({ registros, totalPaginas, totalRegistros })
      this.toastService.success('Operación exitosa')
      // this.router.navigate(['/finanzas/timbrarDeposito', index])
    })
  }

}

